import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

const TABLET_QUERY = '(max-width: 991px)'

export const useUiStore = defineStore('ui', () => {
  const viewportMatchesTablet = ref(false)
  const mobileMenuOpen = ref(false)
  let mediaQuery: MediaQueryList | null = null

  const isTablet = computed(() => viewportMatchesTablet.value)

  const updateViewport = (event?: MediaQueryListEvent): void => {
    viewportMatchesTablet.value = event?.matches ?? mediaQuery?.matches ?? false
  }

  const startViewportTracking = (): (() => void) => {
    if (typeof window === 'undefined') return () => undefined

    mediaQuery = window.matchMedia(TABLET_QUERY)
    updateViewport()
    mediaQuery.addEventListener('change', updateViewport)

    return () => {
      mediaQuery?.removeEventListener('change', updateViewport)
      mediaQuery = null
    }
  }

  const openMobileMenu = (): void => {
    mobileMenuOpen.value = true
  }

  const closeMobileMenu = (): void => {
    mobileMenuOpen.value = false
  }

  return {
    isTablet,
    mobileMenuOpen,
    startViewportTracking,
    openMobileMenu,
    closeMobileMenu,
  }
})
